import React, { Fragment, useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";

const PassesStatusDropdown = (props) => {
    const { checkServerData } = useContext(BasicContext);
    const { onChange, value, multiple, classN, req, id, disabled } = props;
    const { t } = useTranslation();
    const [options, setOptions] = useState(null);

    const getStatuses = async () => {
        const res = await postMethod("/get-passes-statuses");
        if (checkServerData(res)) {
            const list = res.data.list,
                _list = [];
            _list.push({
                key: 0,
                value: "default",
                text: t("all"),
            });
            list.forEach((e, i) => {
                _list.push({
                    key: i + 1,
                    value: e.up_status_code,
                    text: t(`passes.passStatuses.${e.up_status_code}`),
                });
            });

            setOptions(_list);
        }
    };

    useEffect(() => {
        getStatuses();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Form.Group className={classN ? classN : "mb-3"}>
                <Form.Label>
                    {t(`passes.passesStatus${multiple ? "es" : ""}`)} {req && <span className="text-danger">*</span>}
                </Form.Label>
                {!options ? (
                    <p>{t("loadingData")}</p>
                ) : (
                    <Dropdown
                        placeholder={multiple ? t("chooseMany") : t("choose")}
                        fluid
                        multiple={multiple}
                        selection
                        options={options}
                        onChange={(e, data) => onChange(data.value)}
                        value={value}
                        id={id}
                        disabled={disabled}
                    />
                )}
            </Form.Group>
        </Fragment>
    );
};

export default PassesStatusDropdown;
